import quarterOfYear from "dayjs/plugin/quarterOfYear";
import timezone from "dayjs/plugin/timezone";
import _ from "underscore";
import dayjs from "dayjs";

import { callFunctionIfExists } from "./GeneralUtils";
import FieldUtils from "utils/FieldUtils";
import { AppConfirm } from "./PopupUtil";
dayjs.extend(quarterOfYear);
dayjs.extend(timezone);

export const generatePrefill = (
  prefill,
  variableValues,
  fields,
  setConstructedPrefill
) => {
  let out = [];

  if (!prefill || !_.isArray(prefill)) {
    callFunctionIfExists(setConstructedPrefill, []);
    return [];
  }

  for (let i = 0; i < prefill.length; i++) {
    try {
      _.templateSettings = {
        interpolate: /\{\{(.+?)\}\}/g,
      };

      const prefillField = prefill[i].Field;
      let prefillValue = prefill[i].Value;

      if (!isNaN(prefillValue)) {
        prefillValue = prefillValue?.toString();
      }

      if (
        prefillValue === undefined ||
        prefillValue === null ||
        prefillValue === ""
      )
        continue;

      if (_.isArray(prefillValue)) {
        let outVals = [];

        for (let j = 0; j < prefillValue.length; j++) {
          // Handle static reference prefill
          if (_.isObject(prefillValue[j])) {
            outVals.push(prefillValue[j]);
            continue;
          }

          if (prefillValue[j] && prefillValue[j]?.indexOf("{{record.") >= 0) {
            let fieldAPIName = prefillValue[j]
              ?.replace("{{record.", "")
              ?.replace("}}", "");

            if (fieldAPIName === "id" && variableValues.record) {
              out.push({
                Field: prefillField,
                Value: {
                  _ModuleAPIName: variableValues.record?._ModuleAPIName,
                  id: variableValues.record?.id,
                  _RecordName: variableValues?.record?._RecordName,
                },
              });

              continue;
            }

            let field = _.findWhere(fields, { APIName: fieldAPIName });

            if (!field) continue;

            if (field?.FieldType === "SingleReference") {
              outVals.push({
                Field: prefillField,
                Value: {
                  id: variableValues?.record?.id,
                  _ModuleAPIName: variableValues?.record?._ModuleAPIName,
                  _RecordName: variableValues?.record?._RecordName,
                },
              });

              continue;
            } else if (field?.FieldType === "MultiReference") {
              outVals.push({
                Field: prefillField,
                Value: [
                  {
                    id: variableValues?.record?.id,
                    _ModuleAPIName: variableValues?.record?._ModuleAPIName,
                    _RecordName: variableValues?.record?._RecordName,
                  },
                ],
              });

              continue;
            }
          }

          let valTemplate = _.template(prefillValue[j]);

          outVals.push(valTemplate(variableValues));
        }

        out.push({
          Field: prefill[i].Field,
          Value: outVals,
        });
      } else if (_.isObject(prefillValue)) {
        out.push({ Field: prefillField, Value: prefillValue });
      } else {
        if (prefillValue && prefillValue?.indexOf("{{record.") >= 0) {
          let fieldAPIName = prefillValue
            ?.replace("{{record.", "")
            ?.replace("}}", "");

          let field2 = _.findWhere(fields, { APIName: prefillField });

          const splitAPIName = fieldAPIName.split(".");

          // Handle Subitem Prefill
          if (splitAPIName.length > 1) {
            const val =
              variableValues.record?.[splitAPIName[0]]?.[splitAPIName[1]];

            out.push({
              Field: prefillField,
              Value: field2?.FieldType === "MultiReference" ? [val] : val,
            });

            continue;
          }

          if (fieldAPIName === "id") {
            out.push({
              Field: prefillField,
              Value:
                field2?.FieldType === "MultiReference"
                  ? [
                      {
                        _ModuleAPIName: variableValues.record?._ModuleAPIName,
                        id: variableValues.record?.id,
                        _RecordName: variableValues?.record?._RecordName,
                      },
                    ]
                  : {
                      _ModuleAPIName: variableValues.record?._ModuleAPIName,
                      id: variableValues.record?.id,
                      _RecordName: variableValues?.record?._RecordName,
                    },
            });

            continue;
          }

          let field = _.findWhere(fields, { APIName: prefillField });

          if (FieldUtils.isReference(field)) {
            out.push({
              Field: prefillField,
              Value:
                field?.FieldType === "MultiReference"
                  ? [variableValues.record[fieldAPIName]]
                  : variableValues.record[fieldAPIName],
            });

            continue;
          }
        }

        if (prefillValue && prefillValue?.indexOf("{{user.") >= 0) {
          let field = _.findWhere(fields, { APIName: prefillField });

          let fieldAPIName = prefillValue
            ?.replace("{{user.", "")
            ?.replace("}}", "");

          if (fieldAPIName === "id") {
            if (field?.FieldType === "SingleReference") {
              out.push({
                Field: prefillField,
                Value: variableValues.user,
              });
            } else if (field?.FieldType === "MultiReference") {
              out.push({
                Field: prefillField,
                Value: [variableValues.user],
              });
            }

            continue;
          }
        }

        if (prefillValue && prefillValue?.indexOf("{{time.") >= 0) {
          const dynamic = generateTimePrefills({ value: prefillValue });

          out.push({
            Field: prefillField,
            Value: dynamic?.Default || dynamic?.Value,
          });

          continue;
        }

        let valTemplate = _.template(prefillValue);

        let userKeys = _.keys(variableValues?.user);
        let recordKeys = _.keys(variableValues?.record);

        for (let i = 0; i < recordKeys.length; i++) {
          if (
            typeof variableValues?.record[recordKeys[i]] === "object" &&
            variableValues?.record[recordKeys[i]] !== null
          ) {
            try {
              variableValues.record[recordKeys[i]] = JSON.stringify(
                variableValues.record[recordKeys[i]]
              );
            } catch (e) {}
          }
        }

        for (let i = 0; i < userKeys.length; i++) {
          if (
            typeof variableValues?.user[userKeys[i]] === "object" &&
            variableValues?.user[userKeys[i]] !== null
          ) {
            try {
              variableValues.user[userKeys[i]] = JSON.stringify(
                variableValues.user[userKeys[i]]
              );
            } catch (e) {}
          }
        }

        let val = valTemplate(variableValues);

        try {
          let out = JSON.parse(val);

          if (typeof out === "number") {
            const field = _.findWhere(fields, { APIName: prefillField });

            if (["SingleSelect", "MultiSelect"].includes(field?.FieldType)) {
              out = out.toString();
            }
          }

          val = out;
        } catch (e) {}

        try {
          out.push({
            Field: prefillField,
            Value: val,
          });
        } catch (e) {}
      }
    } catch (e) {
      console.error(e);
    }
  }

  callFunctionIfExists(setConstructedPrefill, out);

  return out;
};

export const generateTimePrefills = ({ value, method = "equals" }) => {
  let now = dayjs();
  const startToday = dayjs(now).startOf("day");
  const endToday = dayjs(now).endOf("day");
  const isBetweenMethod = ["between", "not-between"].includes(method);
  const isExactMatch = ["equals", "not-equals"].includes(method);
  const timeZone = dayjs.tz.guess();

  switch (value) {
    case "{{time.now}}":
      return isBetweenMethod
        ? {
            Max: new Date(Date.now()).toISOString(),
            Min: new Date(Date.now()).toISOString(),
          }
        : {
            Value: new Date(Date.now()).toISOString(),
            Default: startToday.hour(12).minute(0).format(),
            ...(isExactMatch && { Interval: "day", TimeZone: timeZone }),
          };
    case "{{time.today}}":
      return isBetweenMethod
        ? {
            Max: endToday.format(),
            Min: startToday.format(),
          }
        : {
            Value: startToday.format(),
            Default: startToday.hour(12).minute(0).format(),
            ...(isExactMatch && { Interval: "day", TimeZone: timeZone }),
          };
    case "{{time.yesterday}}":
      return isBetweenMethod
        ? {
            Min: startToday.subtract(1, "days").format(),
            Max: endToday.subtract(1, "days").format(),
          }
        : {
            Value: startToday.subtract(1, "days").format(),
            Default: startToday.hour(12).minute(0).format(),
            ...(isExactMatch && { Interval: "day", TimeZone: timeZone }),
          };
    case "{{time.tomorrow}}":
      return isBetweenMethod
        ? {
            Min: startToday.format(),
            Max: startToday.add(1, "days").format(),
          }
        : {
            Value: startToday.add(1, "days").format(),
            Default: startToday
              .add(1, "days")
              .startOf("day")
              .hour(12)
              .minute(0)
              .format(),
            ...(isExactMatch && { Interval: "day", TimeZone: timeZone }),
          };
    case "{{time.week}}": {
      const startWeek = dayjs(startToday).startOf("day").startOf("week");
      const endWeek = dayjs(startToday).endOf("day").endOf("week");

      return isBetweenMethod
        ? {
            Min: startWeek.format(),
            Max: endWeek.format(),
          }
        : {
            Value: startWeek.format(),
            Default: startWeek.hour(12).minute(0).format(),
            ...(isExactMatch && { Interval: "week", TimeZone: timeZone }),
          };
    }
    case "{{time.lastWeek}}": {
      const nowReference = startToday.subtract(7, "days");
      const startWeek = dayjs(nowReference).startOf("day").startOf("week");
      const endWeek = dayjs(nowReference).endOf("day").endOf("week");

      return isBetweenMethod
        ? {
            Min: startWeek.format(),
            Max: endWeek.format(),
          }
        : {
            Value: startWeek.format(),
            Default: startWeek.hour(12).minute(0).format(),
            ...(isExactMatch && { Interval: "week", TimeZone: timeZone }),
          };
    }
    case "{{time.nextWeek}}": {
      const nowReference = startToday.add(7, "days");
      const startWeek = dayjs(nowReference).startOf("day").startOf("week");
      const endWeek = dayjs(nowReference).endOf("day").endOf("week");

      return isBetweenMethod
        ? {
            Min: startWeek.format(),
            Max: endWeek.format(),
          }
        : {
            Value: startWeek.format(),
            Default: startWeek.hour(12).minute(0).format(),
            ...(isExactMatch && { Interval: "week", TimeZone: timeZone }),
          };
    }
    case "{{time.month}}": {
      const startMonth = dayjs().startOf("month");
      const endMonth = dayjs().endOf("month");

      return isBetweenMethod
        ? {
            Min: startMonth.format(),
            Max: endMonth.format(),
          }
        : {
            Value: startMonth.format(),
            Default: startMonth.hour(12).minute(0).format(),
            ...(isExactMatch && { Interval: "month", TimeZone: timeZone }),
          };
    }
    case "{{time.lastMonth}}": {
      const nowReference = startToday.subtract(1, "month");
      const startMonth = dayjs(nowReference).startOf("month");
      const endMonth = dayjs(nowReference).endOf("month");

      return isBetweenMethod
        ? {
            Min: startMonth.format(),
            Max: endMonth.format(),
          }
        : {
            Value: startMonth.format(),
            Default: startMonth.hour(12).minute(0).format(),
            ...(isExactMatch && { Interval: "month", TimeZone: timeZone }),
          };
    }
    case "{{time.nextMonth}}": {
      const nowReference = startToday.add(1, "month");
      const startMonth = dayjs(nowReference).startOf("month");
      const endMonth = dayjs(nowReference).endOf("month");

      return isBetweenMethod
        ? {
            Min: startMonth.format(),
            Max: endMonth.format(),
          }
        : {
            Value: startMonth.format(),
            Default: startMonth.hour(12).minute(0).format(),
            ...(isExactMatch && { Interval: "month", TimeZone: timeZone }),
          };
    }
    case "{{time.year}}": {
      const startYear = dayjs(startToday).startOf("day").startOf("year");
      const endYear = dayjs(startToday).endOf("day").endOf("year");

      return isBetweenMethod
        ? {
            Min: startYear.format(),
            Max: endYear.format(),
          }
        : {
            Value: startYear.format(),
            Default: startYear.hour(12).minute(0).format(),
            ...(isExactMatch && { Interval: "year", TimeZone: timeZone }),
          };
    }
    case "{{time.lastYear}}": {
      const referenceDate = startToday.subtract(1, "years");
      const startYear = dayjs(referenceDate).startOf("day").startOf("year");
      const endYear = dayjs(referenceDate).endOf("day").endOf("year");

      return isBetweenMethod
        ? {
            Min: startYear.format(),
            Max: endYear.format(),
          }
        : {
            Value: startYear.format(),
            Default: startYear.hour(12).minute(0).format(),
            ...(isExactMatch && { Interval: "year", TimeZone: timeZone }),
          };
    }
    case "{{time.nextYear}}": {
      const referenceDate = startToday.add(1, "years");
      const startYear = dayjs(referenceDate).startOf("day").startOf("year");
      const endYear = dayjs(referenceDate).endOf("day").endOf("year");

      return isBetweenMethod
        ? {
            Min: startYear.format(),
            Max: endYear.format(),
          }
        : {
            Value: startYear.format(),
            Default: startYear.hour(12).minute(0).format(),
            ...(isExactMatch && { Interval: "year", TimeZone: timeZone }),
          };
    }
    case "{{time.quarter}}": {
      const startQuarter = dayjs(startToday).startOf("day").startOf("quarter");
      const endQuarter = dayjs(startToday).endOf("day").endOf("quarter");

      return isBetweenMethod
        ? {
            Min: startQuarter.format(),
            Max: endQuarter.format(),
          }
        : {
            Value: startQuarter.format(),
            Default: startQuarter.hour(12).minute(0).format(),
            ...(isExactMatch && { Interval: "quarter", TimeZone: timeZone }),
          };
    }
    case "{{time.lastQuarter}}": {
      const referenceDate = startToday.subtract(1, "quarter");
      const startQuarter = dayjs(referenceDate).startOf("quarter");
      const endQuarter = dayjs(referenceDate).endOf("quarter");

      return isBetweenMethod
        ? {
            Min: startQuarter.format(),
            Max: endQuarter.format(),
          }
        : {
            Value: startQuarter.format(),
            Default: startQuarter.hour(12).minute(0).format(),
            ...(isExactMatch && { Interval: "quarter", TimeZone: timeZone }),
          };
    }
    case "{{time.nextQuarter}}": {
      const referenceDate = startToday.add(1, "quarter");
      const startQuarter = dayjs(referenceDate).startOf("quarter");
      const endQuarter = dayjs(referenceDate).endOf("quarter");

      return isBetweenMethod
        ? {
            Min: startQuarter.format(),
            Max: endQuarter.format(),
          }
        : {
            Value: startQuarter.format(),
            Default: startQuarter.hour(12).minute(0).format(),
            ...(isExactMatch && { Interval: "quarter", TimeZone: timeZone }),
          };
    }
    default:
      return {};
  }
};

export function handleSaveGlobalQC({
  quickCreate,
  navigate,
  tenantID,
  onSave,
}) {
  if (!!quickCreate?.GlobalID) {
    return AppConfirm({
      title: "Manage Cloud Quick Creates?",
      html: `
          <div class="font-weight-500 mb-2">You can't unset a global quick create here.</div>
          To manage global quick creates, visit the cloud quick creates settings by clicking the button below.
        `,
      icon: "warning",
      confirmButtonColor: "var(--primary)",
      confirmButtonText: "Go to settings",
    }).then((res) => {
      if (!res.isConfirmed) return;

      navigate(`/clouds/${tenantID}/settings/globals/QuickCreates`);
    });
  }

  AppConfirm({
    title: "Confirm",
    html: `
          <div class="font-weight-500 mb-2">Are you sure you want to make this Quick Create Global?</div>
          It will appear inside of the "Quick Activity" button on the sidebar.
        `,
    icon: "warning",
    confirmButtonColor: "var(--primary)",
    confirmButtonText: "Yes",
    showLoaderOnConfirm: true,
  }).then((confirmation) => {
    if (!confirmation.isConfirmed) return;

    onSave();
  });
}

export function getPrefillValue({ prefill, fieldAPIName }) {
  const prefillField = prefill?.PrefillPairs?.find(
    (item) => item.Field === fieldAPIName
  );
  return prefillField?.Value || "";
}
